import React from "react"
import { Link } from "gatsby-theme-material-ui"
import { Container, Grid, Typography, Button } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import AustrianFlag from "./AustrianFlag"

const FooterStyle = theme => ({
  root: {
    paddingTop: theme.spacing(5),
    height: "20rem",
  },
  gridList: {
    marginTop: theme.spacing(4),
  },
  gridTile: {
    //border: "solid 1px lightgrey",
    "& img": {
      // height: '50px',
      // width: 'auto',
      filter: "grayscale(100%)",
      "&:hover": {
        filter: "none",
      },
    },
  },
  icon: {
    height: "1.5ex",
    width: "auto",
    "@supports (-ms-ime-align:auto)": {
      height: "12px",
      width: "12px",
    },
  },
})

const useStyles = makeStyles(FooterStyle)

export default function Footer({ lang = "de" }) {
  const classes = useStyles()
  return (
    <Container maxWidth="lg" className={classes.root} component="footer">
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Button to="/en/impressum/" color="primary" component={Link}>
            Imprint
          </Button>
          <Button to="/en/data-privacy/" color="primary" component={Link}>
            Data Privacy
          </Button>
        </Grid>
        <Grid item>
          <Typography>
            {" "}
            © {new Date().getFullYear()} Andreas Heissenberger, made in{" "}
            <AustrianFlag className={classes.icon} /> Austria{" "}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item>
          <ul>
            <li>
              <Link to="/en/" color="secondary">
                Home
              </Link>
            </li>
            <li>
              <Link to="/marketing-software-entwicklung/" color="secondary">
                Digitales Marketing &amp; Agile Software Development
              </Link>
            </li>
            {/* <li><Link to='/referenz-projekte/' color='secondary'>Referenzprojekte</Link></li> */}

            <li>
              <Link to="/en/blog/" color="secondary">
                Blog
              </Link>
            </li>
            <li>
              <Link to="/en/tags/" color="secondary">
                Tags
              </Link>
            </li>
            <li>
              <Link to="/" color="secondary">
                Deutsch
              </Link>
            </li>
          </ul>
        </Grid>
      </Grid>
    </Container>
  )
}
